import styled, { css } from 'styled-components';
import bookmarkIconWhite from 'images/icons/bookmark_white.svg';

export const StyledBookmarkIcon = styled.div`
  width: 7px;
  height: 11px;
  margin-left: 2px;
  transition: all 0.3s ease;
  background: url('${bookmarkIconWhite}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.7;
  transition: all .15s ease-out;
  transform: scale(1);
  will-change: transform;

  &:hover {
    transform: scale(1.2);
  }

  &:active {
    transform: scale(1.3);
  }

  &:after {
    content: '';
    pointer-events: none;
    position: absolute;
    top: -13px;
    left: -14px;
    width: 35px;
    height: 35px;
    border-radius: 100%;
    z-index: -1;
    background: white;
    transform: scale(.2);
    opacity: 1;
    transition: transform 0.7s cubic-bezier(0, 1.1, 0.58, 1),opacity 0.7s;
  }

  ${({ selected }) => selected && css`
    opacity: 1;

    &:after {
      transform: scale(1);
      opacity: 0;
    }
  `}
`;
